import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import InnerPageLayout from '../components/ui/InnerPageLayout';
import Accordion from '../components/ui/Accordion';
import PageSEO from '../components/legal/PageSEO';
import SummaryCards from '../components/legal/SummaryCards';
import SectionHeading from '../components/legal/SectionHeading';
import ContactCTA from '../components/legal/ContactCTA';
import { SAFETY_SUMMARY_CARDS, SAFETY_SECTIONS } from '../content/safetyContent';

function Safety() {
  const [openSection, setOpenSection] = useState(0);

  return (
    <InnerPageLayout
      tag="Trust • Queer-Safe • Human"
      title="Built for Safer"
      titleAccent="Queer Connection"
      description="Queer safety is different. Privacy matters. Trust matters. This is how StrapIn is designed to protect connection — without exposure."
      wide
    >
      <PageSEO
        title="Safety Center"
        description="StrapIn Safety — screenshot protection, public and private verification, closeted user privacy, reporting, scam prevention, and safer meetup guidance."
        path="/safety"
      />

      <section className="mb-10 -mt-4">
        <div className="glass-card mx-auto max-w-3xl border-primary/20 bg-gradient-to-br from-primary/10 to-transparent p-6 text-center md:p-8">
          <p className="text-base leading-relaxed text-mist md:text-lg">
            Within seconds, you should feel this:{' '}
            <strong className="text-white">these people understand queer realities.</strong>
            {' '}Not fear marketing — real product choices for privacy, discretion, and respect.
          </p>
        </div>
      </section>

      <section className="mb-16">
        <SectionHeading
          tag="How we protect you"
          title="Safety at a Glance"
          description="Tools and principles designed for LGBTQ+ users — especially those who are closeted or privacy-conscious."
        />
        <SummaryCards items={SAFETY_SUMMARY_CARDS} columns="sm:grid-cols-2 xl:grid-cols-3" />
      </section>

      <section id="safety-details" className="mb-16">
        <SectionHeading
          tag="Learn more"
          title="How StrapIn Keeps You Safer"
          description="Warm, clear guidance — not legalese. Expand any topic below."
        />
        <Accordion items={SAFETY_SECTIONS} openIndex={openSection} onToggle={setOpenSection} />
      </section>

      <section className="mb-16 grid gap-4 sm:grid-cols-2">
        <Link
          to="/privacy"
          className="glass-card-hover group block p-6 no-underline"
        >
          <span className="text-2xl">🔐</span>
          <h3 className="mt-3 font-bold text-white group-hover:text-primary">Privacy Policy</h3>
          <p className="mt-2 text-sm text-silver">
            How we collect, store, and protect your data — including verification and deletion rights.
          </p>
        </Link>
        <Link
          to="/terms"
          className="glass-card-hover group block p-6 no-underline"
        >
          <span className="text-2xl">📜</span>
          <h3 className="mt-3 font-bold text-white group-hover:text-primary">Terms of Service</h3>
          <p className="mt-2 text-sm text-silver">
            Community rules, consent standards, and what happens when someone crosses the line.
          </p>
        </Link>
      </section>

      <ContactCTA
        icon="💜"
        title="We Are Here for You"
        description="Report in-app first for fastest review. For safety concerns or support, reach our team directly."
        emails={[
          { label: 'safety@strapinapp.com', href: 'mailto:safety@strapinapp.com' },
          { label: 'support@strapinapp.com', href: 'mailto:support@strapinapp.com' },
        ]}
        links={[{ label: 'Help Center', to: '/help' }]}
      />
    </InnerPageLayout>
  );
}

export default Safety;
